import Axios from 'axios';
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';
import { PANEL_URL } from 'components/windowEnvs';

const axios = Axios.create({
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-APP-VER': 'fl',
  },
  crossDomain: true,
  withCredentials: true,
  baseURL: PANEL_URL
});

axios.interceptors.request.use(
  function (config) {
    const token = LocalStorageHelper.getToken();
    const locale = LocalStorageHelper.getLocale();
    if (token) {
      config.headers['X-AUTH-TOKEN'] = token;
    }
    if (locale) {
      config.headers['Locale'] = locale;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

function getCsrfToken() {
  var noWindow = (typeof window === 'undefined');
  if (noWindow) return "";
  let el = document.getElementById('csrfToken') || document.querySelectorAll('[name=csrf-token]')[0];

  if (el) {
    if (el.textContent.length) {
      return el.textContent.trim();
    } else {
      return el.getAttribute('content');
    }
  }
}

export default axios;
